<div
    class="card"
    [attr.data-severity]="notification().severity"
    (mouseenter)="onHoverStart()"
    (mouseleave)="onHoverEnd()"
    (focusin)="onFocusIn()"
    (focusout)="onFocusOut($event)"
>
    @switch (notification().severity) {
        @case ('success') {
            <svg class="card__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                />
            </svg>
        }
        @case ('warning') {
            <svg class="card__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
            </svg>
        }
        @case ('error') {
            <svg class="card__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                />
            </svg>
        }
        @default {
            <svg class="card__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                />
            </svg>
        }
    }

    <p class="card__text">{{ notification().message }}</p>

    @if (notification().action; as action) {
        <button type="button" class="card__action" (click)="runAction()">{{ action.label }}</button>
    }

    <button type="button" class="card__close" aria-label="Закрыть уведомление" (click)="close()">
        <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
                d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
        </svg>
    </button>
</div>
